export var PackagePickerIds;
(function (PackagePickerIds) {
    PackagePickerIds["UNLIMITED"] = "1,2,3,4";
    PackagePickerIds["MULTI_CHANNEL"] = "1,2,4";
    PackagePickerIds["SELF_SERVICE"] = "1";
    PackagePickerIds["CALL_CENTER"] = "2,3,4";
})(PackagePickerIds || (PackagePickerIds = {}));
//# sourceMappingURL=package-picker.js.map